import { RecordingCreationType, RecordingUUIDUser } from "@/models/recording";
import postRecoverRecordingUUID from "@/services/postRecoverRecordingUUID";
import { reportError } from "@/utils/reportError";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

// TODO: Implement components to use this new query structure
//       using "react-query"
const usePostRecoverRecordingUUID = () => {
  const { mutate, mutateAsync, isPending, isError, error, data } = useMutation<
    string,
    AxiosError,
    { agendaId: string; recordingUUIDUsers: RecordingUUIDUser[]; language: string; recordingType?: RecordingCreationType }
  >({
    mutationFn: async ({ agendaId, recordingUUIDUsers, language, recordingType }) => {
      const result = await postRecoverRecordingUUID(agendaId, recordingUUIDUsers, language, recordingType);

      if (result instanceof AxiosError) {
        throw result;
      }

      return result;
    },
    mutationKey: ["postRecoverRecordingUUID"],
    onError: (error: AxiosError) => {
      reportError(error, {
        eventName: "POST-RECOVER-RECORDING-UUID",
        properties: {
          reason: `Error recovering recording UUID - ${error?.message}`,
        },
      });
    },
  });

  return { mutate, mutateAsync, isPending, isError, error, data };
};

export default usePostRecoverRecordingUUID;
